import apiEndpoints from '../../../api';
import { clean, url, listParams, bodyOf, getReq, writeReq } from './vmsHttp';

export const getCabsListReq = (action) => {
    const d = action.data;
    return getReq(apiEndpoints.SOCIETY_GET_CABS_LIST_API, listParams(d, {
        status: d?.status,
        flat_id: d?.flatId,
        cab_type: d?.cabType,
    }), 'Failed to load cabs');
};

export const getCabDetailsReq = (action) =>
    getReq(url(apiEndpoints.SOCIETY_GET_CAB_DETAILS_API, { id: action.data.id }),
        undefined, 'Failed to load cab log');

// requested_by defaults to the calling user server-side — only sent when
// logging a cab on someone else's behalf.
export const createCabReq = (action) =>
    writeReq('post', apiEndpoints.SOCIETY_CREATE_CAB_API, clean(bodyOf(action.data)),
        'Cab logged', 'Failed to log cab');

// visit_id, requested_by and the ownership keys are fixed at creation. `status`
// IS editable here — it is how a cab reaches WAITING, NO_SHOW or CANCELLED.
export const updateCabReq = (action) =>
    writeReq('put', url(apiEndpoints.SOCIETY_UPDATE_CAB_API, { id: action.data.id }),
        bodyOf(action.data, ['flat_id', 'wing_id', 'visit_id', 'society_id', 'requested_by']),
        'Cab updated', 'Failed to update cab');

export const deleteCabReq = (action) =>
    writeReq('delete', url(apiEndpoints.SOCIETY_DELETE_CAB_API, { id: action.data.id }),
        undefined, 'Cab log removed', 'Failed to remove cab log');

// Takes no body; sets COMPLETED and stamps departed_at. Unguarded server-side,
// same as deliveries.
export const completeCabReq = (action) =>
    writeReq('post', url(apiEndpoints.SOCIETY_COMPLETE_CAB_API, { id: action.data.id }), {},
        'Cab trip completed', 'Failed to complete cab trip');
